var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 74 74",
    height: 74,
    viewBox: "0 0 74 74",
    width: 74,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 30,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24.1,
    cy: 29.1,
    r: 5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 49.9,
    cy: 29.1,
    r: 5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m49.2 49.8c-6.7 6.7-17.6 6.7-24.3 0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37 69c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm0-60c-15.4 0-28 12.6-28 28s12.6 28 28 28 28-12.6 28-28-12.6-28-28-28z",
    fill: "#a8e1f4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.1 36.1c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm0-10c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z",
    fill: "#1380d2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m49.9 36.1c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.2 7-7 7zm0-10c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.4-3-3-3z",
    fill: "#1380d2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37 56.8c-5.1 0-10-2-13.6-5.6-.8-.8-.8-2 0-2.8s2-.8 2.8 0c2.9 2.9 6.7 4.5 10.8 4.5s7.9-1.6 10.8-4.5c.8-.8 2-.8 2.8 0s.8 2 0 2.8c-3.6 3.6-8.5 5.6-13.6 5.6z",
    fill: "#1380d2"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37 5c-17.6 0-32 14.4-32 32s14.4 32 32 32 32-14.4 32-32-14.4-32-32-32zm-17.9 24.1c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5c-2.7 0-5-2.2-5-5zm31.5 22.1c-3.6 3.6-8.4 5.6-13.6 5.6-5.1 0-10-2-13.6-5.6-.8-.8-.8-2 0-2.8s2-.8 2.8 0c2.9 2.9 6.7 4.5 10.8 4.5s7.9-1.6 10.8-4.5c.8-.8 2-.8 2.8 0s.8 2 0 2.8zm-.7-17.1c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.3 5-5 5z",
    display: "inline"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37 5c-17.6 0-32 14.4-32 32s14.4 32 32 32 32-14.4 32-32-14.4-32-32-32zm-17.9 24.1c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5c-2.7 0-5-2.2-5-5zm31.5 22.1c-3.6 3.6-8.4 5.6-13.6 5.6-5.1 0-10-2-13.6-5.6-.8-.8-.8-2 0-2.8s2-.8 2.8 0c2.9 2.9 6.7 4.5 10.8 4.5s7.9-1.6 10.8-4.5c.8-.8 2-.8 2.8 0s.8 2 0 2.8zm-.7-17.1c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.3 5-5 5z",
    display: "inline",
    fill: "#ff8e23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiIcon);
export default __webpack_public_path__ + "static/media/emoji-icon.af92a2be29e8334ccdc2430cc61f3824.svg";
export { ForwardRef as ReactComponent };